/* ===========================
IMPORTS
=========================== */
import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
// // IMPORT - COMPONENTS
import CanvasDetails from './Details';
import CanvasHistory from './History';
import CanvasComments from './Comments';
// IMPORT - ELEMENTS
// IMPORT - Helpers

/* ===========================
CLASS
=========================== */
class CanvasView extends React.Component {
  /* ===========================
  DEFAULT
  =========================== */
  /**
  * Main constructor of Component
  */
  constructor(props) {
    super(props);
    this.state = {
      id: (this.props.match.params.id || null),
    };

    this.renderSection = this.renderSection.bind(this);
  }

  /**
  * componentDidMount
  */
  componentDidMount() {
    // Show the component
    this.props.updateLoadingApp(false);
    this.props.updateLoadingContent(false);
  }

  /* ===========================
  FUNCTIONS
  =========================== */

  /**
   * @param {string} section
   */
  renderSection(section) {
    switch (section) {
      case 'details':
        return (<CanvasDetails id={this.props.match.params.id} />);
      case 'history':
        return (<CanvasHistory id={this.props.match.params.id} />);
      case 'comments':
        return (<CanvasComments id={this.props.match.params.id} />);
      default:
        return '';
    }
  }

  /* ===========================
  RENDER
  =========================== */

  render() {
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col col-12">

            <div className="page-header">
              <h1>
                Canvases
                <span>{(this.state.id) ? `ID ${this.state.id}` : ''}</span>
              </h1>
            </div>

            <div className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col col-12">
                    <ul className="nav nav-tabs">
                      <li className="nav-item">
                        <Link className={`nav-link ${(this.props.match.params.section === 'details') ? 'active' : ''}`} to={`/dashboard/canvases/${this.state.id}/details`}>Details</Link>
                      </li>
                      <li className="nav-item">
                        <Link className={`nav-link ${(this.props.match.params.section === 'history') ? 'active' : ''}`} to={`/dashboard/canvases/${this.state.id}/history`}>History</Link>
                      </li>
                      <li className="nav-item">
                        <Link className={`nav-link ${(this.props.match.params.section === 'comments') ? 'active' : ''}`} to={`/dashboard/canvases/${this.state.id}/comments`}>Comments</Link>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="content-inner">
                  {this.renderSection(this.props.match.params.section)}
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

/* ===========================
PROPERTY TYPES
=========================== */
CanvasView.propTypes = {
  match: PropTypes.object,
  updateLoadingApp: PropTypes.func,
  updateLoadingContent: PropTypes.func,
};

/* ===========================
EXPORT
=========================== */
export default withRouter(CanvasView);
